export const SOCCER_POSITIONS = [
  {
    key: "goalkeepers",
    type: "group",
    label: "Goalkeepers",
    children: [{ key: "1", label: "1" }],
  },
  {
    key: "defenders",
    type: "group",
    label: "Defenders",
    children: [
      { key: "2/3", label: "2/3" },
      { key: "4/5", label: "4/5" },
    ],
  },
  {
    key: "midfielders",
    type: "group",
    label: "Midfielders",
    children: [
      { key: "6", label: "6" },
      { key: "8/10", label: "8/10" },
    ],
  },
  {
    key: "forwards",
    type: "group",
    label: "Forwards",
    children: [
      { key: "7/11", label: "7/11" },
      { key: "9", label: "9" },
    ],
  },
];

export const getNestedPositionSelectOptions = (positions, sport) => {
  if (sport === "soccer") return SOCCER_POSITIONS;
  const tree = {};
  for (let position of positions) {
    if (position === null) continue;
    let index = position.indexOf("-");
    if (index === -1) index = position.length;
    const key = position.substring(0, index).trim();
    const value = position.substring(index + 1).trim();
    if (value) {
      if (!Array.isArray(tree[key])) tree[key] = [];
      tree[key].push({ key: position, label: value });
    } else {
      tree[key] = true;
    }
  }
  return Object.keys(tree).map((key) => {
    if (tree[key] === true) {
      return {
        key: key,
        label: key,
      };
    } else {
      return {
        key: key,
        label: key,
        children: tree[key],
      };
    }
  });
};
